import { types } from '../types'

const initialState = {
    Waiting: false,
    Success: false,
    Error: '',
    notificationCount:0

}

const notificationReducer = (state = initialState, { type, action, error }) => {
    switch (type) {
        case types.NOTIICATION_COUNT_REQUEST: {
            return {
                ...state,
                Waiting: true,
                Success: false,
            }
        }

        case types.NOTIICATION_COUNT_ERROR: {
            return {
                ...state,
                Waiting: false,
                Error: "00000",
            }
        }
        case types.NOTIICATION_COUNT_SUCCESS: {
           
            return {
                ...state,
                Waiting: false,
                Success: true,
                notificationCount:action.data
            }
        }

        case types.NOTIICATION_COUNT_RESET_PROPS: {
            return {
                ...state,
                Waiting: false,
                Success: false,
                Error: '',
            }
        }

        default:
            return state
    }
}

export default notificationReducer
